import React, { useState } from "react";
import { deleteRoles, getRoles } from "../../../MyApi/vendors";
import { useQuery } from "react-query";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";
import Can from "../../../utils/can";
import RolesModal from "../../../Components/system settings/storemodals/rolesmodal";
import DataTable from "../../../Components/UI/table/DataTable";

const RolesTab = () => {
  const [isModalOpen, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const [modalId, setModalId] = useState("");
  const rolesColumns = [
    { label: "المعرف ", accessor: "id" },
    { label: "الاسم ", accessor: "name" },
    {
      label: "الحالة",
      render: (row) => <StatusBadge status={"active"} />,
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          deleteFn={deleteRoles}
          deletePermission={"delete_role"}
          id={row.id}
          queryKey={"getRoles"}
          edit={() => openModal("edit", row.id)}
          editPermission={"update_role"}
        />
      ),
    },
  ];

  const { data, isLoading, refetch } = useQuery(
    ["getRoles"],

    ()=>getRoles(),
  );
  const roles = data?.data?.roles;

  const openModal = (mode, id) => {
    setOpenModal(true);
    setModalMode(mode);
    setModalId(id);
  };
  const closeModal = () => {
    setOpenModal(false);
    setModalId(null);
  };

  const handleAddClick = () => {
    openModal("add", null);
  };

  return (
    <div>
      <Can permission={"view_role"}>
        <DataTable
          actionLabel={"إضافة أدوار"}
          onAddClick={handleAddClick}
          title={"الأدوار"}
          columns={rolesColumns}
          data={roles}
          isLoading={isLoading}
          createPermission={"create_role"}
        />
      </Can>

      {isModalOpen && (
        <RolesModal
          show={isModalOpen}
          onClose={closeModal}
          refetch={refetch}
          mode={modalMode}
          id={modalId}
        />
      )}
    </div>
  );
};

export default RolesTab;
